import YaGoals from 'www/modules/YandexGoals'

const ManageYandexGoals = {
  data: () => ({
    yaGoalsInstance: new YaGoals(),
    /**
     * yaGoalsList - Объект со списком целей, которые необходимо подключить в
     * каждом компоненте использующий текущий миксин
     *
     * yaGoalsList: {},
     */
  }),
  methods: {
    sendYandexGoal(goal) {
      if (!this.yaGoalsInstance) {
        return
      }

      if (!goal) {
        return
      }

      const name = this.yaGoalsList[goal]

      if (!name) {
        return
      }

      this.yaGoalsInstance.send({ name })
    },
  },
}

export default ManageYandexGoals
